(ns common.endpoints.updates.fund-commitment-investors
  (:require [malli.core :as m]))

(def profile :fund-commitment-investors)
(def batch-size 50)

(def scope-request
  [:map {:closed true}
   [:profile [:= profile]]
   [:commitment-ids [:vector {:min 1
                              :max batch-size} pos-int?]]])

(defn requested?
  [scope]
  (= profile (:profile scope)))

(defn valid-scope?
  [scope]
  ;; Other scope maps retain the existing entity-scope contract.
  (or (not (requested? scope))
      (m/validate scope-request scope)))
